<!-- Modal Container -->
<template>
  <div>
    <form @submit.prevent="getAudience" action="#"  method="post">

      <div class="panel panel-default">
        <div class="panel-heading">
          <h3 class="panel-title">Criteria Filters:</h3>
        </div>
        <div class="panel-body">
          <div class="row">
      <div class="col-md-12 col-lg-12 col-xs-12">
        <div class="form-group col-xs-6 col-sm-6 col-md-6">
          <label for="name" class="required">Query Name</label>
          <input type="text" v-bind:class="{'form-group--error': submitted && !$v.gRowObj.query_name.required }" v-model="gRowObj.query_name" class="form-control " id="query_name" placeholder="Query Name"  />
          <span v-if="submitted && !$v.gRowObj.query_name.required" class="text-red pull-left">Please enter query name.</span>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12 col-lg-12 col-xs-12">
          <div class="form-group col-xs-6 col-sm-6 col-md-6">
            <label for="name" class="required">Country</label>
            <treeselect 
              id="country"
              :clearable="false"
              placeholder="--Choose a Country--"
              v-bind:class="{'form-group--error': submitted && !$v.gRowObj.country_id.required }" 
              :multiple="false" 
              :options="countryList"
              v-model="gRowObj.country_id" 
              @input="handleCountryChange"/>
              <span v-if="submitted && !$v.gRowObj.country_id.required" class="text-red pull-left">Please choose a country.</span>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12 col-lg-12 col-xs-12">
          <div class="form-group col-xs-6 col-sm-6 col-md-6">
            <label for="name">Folder Name</label>
            <treeselect 
              id="folder"
              :clearable="true"
              placeholder="--Choose a Folder--"
              :multiple="false" 
              :options="folderList"
              v-model="folderId" 
            />
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12 col-lg-12 col-xs-12">
          <div class="form-group col-xs-6 col-sm-6 col-md-6">
            <label for="name">Keyword Topic</label>
            <treeselect 
              id="topic" 
              placeholder="--Choose an operator--" 
              :multiple="false" 
              :options="topicList"
              v-model="gRowObj.topic_id" 
              @input="handleTopicChange"/>
          </div>
        </div>
      </div>
      

      <div class="row">
        <div class="col-md-12 col-lg-12 col-xs-12">
        <div class="form-group col-xs-6 col-sm-6 col-md-6">
          <div class="reload-audience-builder">
          <label for="keyword" style="margin-right: 10px">Keyword(s)</label>
          <div class="refresh-keyword">
            <a href="#"><div title="Click to refresh the contents of the list" class="fa fa-refresh rotate" @click="refreshKeywordsList(param)"></div></a>
          </div>
          </div>
          <treeselect placeholder="Add Keywords" 
            :multiple="true" 
            :options="filteredKeywords" 
            :disabled="keywordDisabled"  
            v-model="gRowObj.keywords"
            @input="update" 
            search-nested/>
        </div>
        <div class="col-xs-3 col-sm-3 col-md-3 col-3">
          <label>&nbsp;</label>
          <treeselect
            :clearable="false"  
            placeholder="--Choose an operator--" 
            :multiple="false" 
            :options="inNotInOptions" 
            :disabled="keywordDisabled || !gRowObj.keywords.length"
            v-model="gRowObj.keyword_operator" />
        </div>
      </div>
      </div>

      <div class="row">
        <div class="col-md-12 col-lg-12 col-xs-12">
          <div class="form-group col-xs-12 col-sm-12 col-md-12">
          <label for="conversations">Conversation(s)</label>
          <span class="ab-hint-text">User has fulfilled these criteria or is currently fulfilling these criteria (ever or currently)</span>
          <div
            v-for="(conversation, index) in gRowObj.conversations"
            v-bind:key="index">
              <div class="row border-grey margin-20 padding-20 col-xs-9 col-sm-9 col-md-9">
              <div class="form-group col-xs-8 col-sm-8 col-md-8">
                <div class="reload-conversation-audience-builder">
                <label for="Conversation" style="margin-right: 10px">Conversation</label>
                <div class="refresh-conversation">
                <a href="#"><div title="Click to refresh the contents of the list" class="fa fa-refresh rotate" @click="getConversationsList()"></div></a>
                </div>
              </div>
                <treeselect 
                  placeholder="Select conversation"
                  :disableBranchNodes="true"
                  :multiple="false"
                  :options="options" 
                  :disabled="conversationDisabled"  
                  v-model="conversation.conversation" 
                  @input="getStageList(conversation.conversation, index)" 
                  search-nested/>
              </div>

              <div class="col-xs-3 col-sm-3 col-md-3 col-3">
                <label>&nbsp;</label>
                <treeselect placeholder="--Choose an operator--"
                  :clearable="false" 
                  :multiple="false" :options="equalNotEqualOptions" 
                  :disabled="!conversation.conversation" 
                  v-model="conversation.conversation_operator"
                  @input="resetStages(index, conversation.conversation_operator)" 
                />
              </div>

              <div class="row">
                <div class="col-md-12 col-lg-12 col-xs-12">
                <div class="form-group col-xs-12 col-sm-12 col-md-12">
              <label for="stages">Stage(s)</label>
                <div
                  v-for="(stage, stageIndex) in conversation.stages"
                  v-bind:key="stageIndex">
                  <div class="border-grey margin-20 padding-20 col-xs-9 col-sm-9 col-md-8">
                    <div class="row">
                    <div class="form-group col-xs-6 col-sm-6 col-md-7 col-7">
                      <label for="stage">Stage</label>
                      <treeselect
                        id="stage"
                        :clearable="false" 
                        placeholder="--Choose a stage--" 
                        :multiple="false" 
                        :options="conversation.stageList"
                        :disabled="!(conversation.conversation_operator == 4)"
                        v-model="stage.stage"
                        @input="getAnswerList(conversation.conversation, stage.stage, index, stageIndex)" />
                    </div>

                    <div class="col-xs-5 col-sm-5 col-md-4 col-4">
                      <label>&nbsp;</label>
                      <treeselect 
                        placeholder="--Choose an operator--"
                        :clearable="false"  
                        :multiple="false" 
                        :options="equalNotEqualOptions" 
                        :disabled="!(conversation.conversation_operator == 4 && stage.stage)"
                        v-model="stage.stage_operator"
                        @input="resetAnswers(index, stageIndex, stage.stage_operator)" 
                      />
                    </div>

                    </div>
                    <div class="row">

                    <div class="form-group col-xs-6 col-sm-6 col-md-7 col-7">
                      <label for="answer">Answer(s)</label>
                      <treeselect
                        :clearable="false"  
                        placeholder="--Choose an operator--" 
                        :multiple="true" 
                        :options="stage.answerList" 
                        :disabled="!(stage.stage_operator == 4) || !stage.answers"
                        v-model="stage.answers" 
                        @input="handleAnswerChange(index, stageIndex, stage.answers, stage.answers_operator)"/>
                    </div>

                    <div class="col-xs-5 col-sm-5 col-md-4 col-4">
                      <label>&nbsp;</label>
                      <treeselect 
                        :clearable="false" 
                        placeholder="--Choose an operator--" 
                        :multiple="false" 
                        :options="inNotInOptions" 
                        :disabled="!(stage.stage_operator == 4 && stage.answers.length)"
                        v-model="stage.answers_operator" />
                    </div>

                  </div>

                  </div>
                  <button type="button" class="btn btn-remove-item btn-danger col-xs-3 col-sm-3 col-md-3 col-3 margin-top-20" @click="deleteStage(index,stageIndex)">Remove Stage</button>
                  </div>
                </div>                                    
                <button type="button" class="btn btn-primary" @click="addStage(index)">Add Stage</button>
              </div>
            </div>
          </div>
            <button type="button" class="btn btn-remove-item btn-danger col-xs-2 col-sm-2 col-md-2 col-2 margin-top-20" @click="deleteConversation(index)">Remove Conversation</button>
        </div>
        </div>
          <button type="button" class="btn btn-primary margin-left-10 margin-bottom-20" @click="addConversation">Add Conversation</button>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12 col-lg-12 col-xs-12">
          <div class="form-group col-xs-12 col-sm-12 col-md-12">
            <label for="conversations">Active Conversation (includes journeys and Jors) selection </label>
            <span class="ab-hint-text">User is actively fulfilling these criteria (currently)</span>
              <div class="row border-grey margin-20 padding-20">
                  <div class="form-group col-xs-8 col-sm-8 col-md-8">
                    <label for="Conversation">Inclusion</label>
                    <span>(when selecting multiple convos, if the user is actively engaging with any one or more convos, they will be included)</span>
                    <div class="reload-inclusion-conversation">
                    <treeselect 
                      placeholder="Select conversation"
                      :disableBranchNodes="true"
                      :multiple="true"
                      :options="options" 
                      :disabled="conversationDisabled"  
                      v-model="gRowObj.active_conversations_include" 
                      search-nested
                      style="margin-right: 10px"/>
                      <div class="refresh-conversation">
                        <a href="#"><div title="Click to refresh the contents of the list" class="fa fa-refresh rotate" @click="getConversationsList()"></div></a>
                      </div>
                    </div>
                  </div>

                  <div class="form-group col-xs-8 col-sm-8 col-md-8">
                    <label for="Conversation">Exclusion</label>
                    <span>(When selecting multiple convos, if the user actively engaging with any one or more convos, they will be excluded)</span>
                    <div class="reload-exclusion-conversation">
                    <treeselect 
                      placeholder="Select conversation"
                      :disableBranchNodes="true"
                      :multiple="true"
                      :options="options" 
                      :disabled="conversationDisabled"  
                      v-model="gRowObj.active_conversations_exclude" 
                      search-nested
                      style="margin-right: 10px"/>
                      <div class="refresh-conversation">
                        <a href="#"><div title="Click to refresh the contents of the list" class="fa fa-refresh rotate" @click="getConversationsList()"></div></a>
                      </div>
                    </div>
                  </div>
              </div>
          </div>
        </div>
      </div>

        <div class="row">
          <div class="col-md-12 col-lg-12 col-xs-12">
          <div class="form-group col-xs-6 col-sm-6 col-md-6">
            <label for="name">Language(s)</label>
            <treeselect 
              placeholder="Add Language(s)" 
              :multiple="true" 
              :options="languages" 
              v-model="gRowObj.language"
              @input="handleLanguageChange"
              search-nested/>
          </div>
          <div class="col-xs-3 col-sm-3 col-md-3 col-3">
            <label>&nbsp;</label>
            <treeselect
              :clearable="false"
              placeholder="--Choose an operator--" 
              :multiple="false" 
              :options="inNotInOptions" 
              :disabled="!gRowObj.language.length"
              v-model="gRowObj.language_operator" />
          </div>
        </div>
        </div>

        <div class="row">
          <div class="col-md-12 col-lg-12 col-xs-12">
            <div class="form-group col-md-12 col-lg-12 col-xs-12">            
              <label for="referral">Referral Status</label>
              <div v-for="referral in referralOptions" :key="referral.value">
                <label class="radio-inline col-xs-4 col-sm-4 col-md-2 col-lg-2">
                  <input type="radio" v-model="gRowObj.referralStatus" :value="referral.value" @change="checkNoteForNotOnboarded"/>{{referral.label}}
                </label>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12 col-lg-12 col-xs-12">
            <div class="form-group col-md-12 col-lg-12 col-xs-12">            
              <label for="referral">Reengagement/Reminder Status</label>
              <div v-for="reminder in reminderOptions" :key="reminder.value">
                <label class="radio-inline col-xs-4 col-sm-2 col-md-2 col-lg-2">
                  <input type="radio" v-model="gRowObj.reminderRestriction" :value="reminder.value"/>{{reminder.label}}
                </label>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12 col-lg-12 col-xs-12">
            <div class="form-group col-md-12 col-lg-12 col-xs-12">            
              <label for="channel">Channel</label>
              <div v-for="channel in channelOptions" :key="channel.value">
                <label class="checkbox-inline col-xs-4 col-sm-4 col-md-3 col-lg-2">
                  <input type="checkbox" v-model="gRowObj.channels" :value="channel.value" />{{channel.label}}
                </label>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12 col-lg-12 col-xs-12">
            <div class="form-group col-md-12 col-lg-12 col-xs-12">            
              <label for="onboard">Onboard Status</label>
              <div v-for="onboard in onboardOptions" :key="onboard.value">
                <label class="checkbox-inline col-xs-4 col-sm-4 col-md-3 col-lg-2">
                  <input type="checkbox" v-model="gRowObj.onboardStatus" :value="onboard.value" @change="checkNoteForNotOnboarded"/>{{onboard.label}}
                </label>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12 col-lg-12 col-xs-12">
            <div class="form-group col-md-12 col-lg-12 col-xs-12">            
              <label for="gender">Gender</label>
              <div v-for="gender in genderOptions" :key="gender.value">
                <label class="checkbox-inline col-xs-4 col-sm-4 col-md-3 col-lg-2">
                  <input type="checkbox" v-model="gRowObj.gender" :value="gender.value" />{{gender.label}}
                </label>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12 col-lg-12 col-xs-12">
            <div class="form-group col-xs-6 col-sm-6 col-md-6">
              <label for="name">Min Age</label>
              <input type="number" v-model="gRowObj.minAge" class="form-control " id="minAge" placeholder="Min Age"  min="0" max="100"/>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12 col-lg-12 col-xs-12">
            <div class="form-group col-xs-6 col-sm-6 col-md-6">
              <label for="name">Max Age</label>
              <input type="number" v-model="gRowObj.maxAge" class="form-control " id="maxAge" placeholder="Max Age" min="0" max="100" />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12 col-lg-12 col-xs-12">
            <div class="form-group col-xs-12 col-sm-12 col-md-">
              <label for="action-dates">Action Dates</label>
                <div>
                  <button type="button" class="btn btn-primary margin-bottom-20" @click="handleDateTypeChange('engagementDate')">Add Engagement Dates</button>&nbsp; &nbsp;
                  <button type="button" class="btn btn-primary margin-bottom-20" @click="handleDateTypeChange('OnboardedDate')">Add Onboarding Dates</button>
                </div>
            </div>
          </div>
        </div>
        <div class="row" style = "padding: 0 30px;" v-show="dateType!==''">
          <div class=" border-grey col-md-12 col-lg-6 col-xs-12 padding-20">
            <div class="row">
              <div class="col-md-12 col-lg-6 col-xs-12">
                <div class="form-group ">
                  <label for="date-from">{{ dateTypeMappings[dateType] }} Start Date(UTC)</label>
                  <input type="date" :max="gRowObj.dateTo" :min="getMinDate(gRowObj.dateTo)" v-model="gRowObj.dateFrom" id="date-from"
                   class="form-control " placeholder="Select Start Date" />
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-12 col-lg-6 col-xs-12">
                <div class="form-group">
                  <label for="date-to">{{ dateTypeMappings[dateType] }} End Date(UTC)</label>
                  <input :min="gRowObj.dateFrom" :max="getMaxDate(gRowObj.dateFrom)" type="date" v-model="gRowObj.dateTo" 
                  id="date-to" class="form-control " 
                  placeholder="Select End Date" />
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-12 col-lg-6 col-xs-12">
            <button type="button" class="btn btn-danger col-xs-6 col-sm-6 col-md-3 col-3 margin-top-20" @click="resetDateType">Remove</button>
          </div>
          <div class="col-md-12 col-lg-6 col-xs-12" style="margin-top: 10px">
        </div>
        </div>
         <div class="col-md-12 col-lg-6 col-xs-12">
        <label class="label-custom">Custom Query</label>
        <span title="One account-id should be there in the custom query"><i class="fa fa-info-circle margin-10"></i></span>
        <textarea v-model="gRowObj.customQuery" rows="4" class="form-control" placeholder="Enter the custom query here"/>
        </div>
      </div>
      </div>
      <label v-show="notOnboardNote" class="note-label">
        Note: Selecting the onboard status "not onboarded" together with an onboarded date returns no data.
      </label>
      <div class="action-button">
        <input type="submit"  class="btn btn-primary" value="Get Audience"/>
        &nbsp; &nbsp;
        <button type="button" class="btn btn-primary" @click="saveAudienceData">{{gRowObj.id ? 'Update' : 'Save'}} Audience</button>
        &nbsp; &nbsp;
        <button type="button" class="btn btn-primary" @click="exportAudience">Export Audience</button>
         &nbsp; &nbsp;
        <button type="button" class="btn btn-primary" @click="openModal()">Export Transcripts</button>
        &nbsp; &nbsp;
        <button type="button" class="btn btn-primary" @click="openModal(true)">Export GenAI Onboarding Transcript</button>
        &nbsp; &nbsp;
      </div>
    </form>
    <BlockUI v-if="loading"><i class="fa fa-cog fa-spin fa-3x fa-fw"></i><br/>Please wait...</BlockUI>
    <AudienceTable :audienceData="audienceData" :audienceCount="audienceCount" :showTable="true"/>
     <div class="modal-backdrop" v-if="showTranscriptModal" >
      <div class="modal modal-md" style="height: 230PX;max-width:600px">
        <header class="modal-header">
          <slot name="header">
            <h3>Get Transcripts</h3>
          </slot>
          <div class="modal-body">
            <slot name="body">
            <div class="form-horizontal">
              <div class="form-group">
                <label for="folderName" style="font-weight:500;text-align:left" class="col-sm-4 control-label required">Type #</label>
                <div class="col-sm-8" style="text-align: left;">
                  <input type="text" class="form-control" v-model="transcriptNumber"/>
                  <span v-if="submittedTransriptNumber && (!$v.transcriptNumber.required || !$v.transcriptNumber.minValue || !$v.transcriptNumber.maxValue)" class="text-red pull-right">Please enter a number between 1-100.</span>
                </div>
              </div>
              <div class="form-group pull-right" style="margin-right:3px;margin-top:20px;">
                <div class="col-sm-12">
                  <button type="button" class="btn btn-primary" @click="closeModal" >Cancel</button>
                  <button type="button" class="btn btn-primary" @click="exportTranscripts" >Submit</button>
                </div>
              </div>
            </div>
            </slot>
          </div>
        </header>
        <footer class="modal-footer"></footer>
      </div>
    </div>
    </div>
</template>
<script>
import Vue from 'vue'
import AudienceTable from './table'
import _ from 'lodash'
import moment from 'moment'
import VueTagsInput from '@johmun/vue-tags-input'
import vSelect from 'vue-select'
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import { required, minValue, maxValue } from 'vuelidate/lib/validators'
import api from '../../../utils/latestApi'
import apiold from '../../../utils/api'
import * as helpers from './helpers'
import { downloadCSV, getEnv } from '../../../utils/utilities'
import { channelOptions, genderOptions } from './../../../config/constants'
import * as formatter from './manageFolder/helpers'
import { languages, dateTypeMappings, equalNotEqualOptions, inNotInOptions, referralOptions, onboardOptions, reminderOptions } from './constants'

Vue.component('v-select', vSelect)
Vue.component('vue-tags-input', VueTagsInput)
Vue.component('treeselect', Treeselect)

export default {
  name: 'modal',
  components: {
    AudienceTable
  },
  validations: {
    transcriptNumber: { required, minValue: minValue(1), maxValue: maxValue(100) },
    gRowObj: {
      country_id: { required },
      query_name: { required }
    }
  },
  data () {
    return {
      audienceData: [],
      audienceCount: 0,
      loading: false,
      keywordDisabled: true,
      notOnboardNote: false,
      conversationDisabled: true,
      inNotInOptions: inNotInOptions,
      equalNotEqualOptions: equalNotEqualOptions,
      env: '',
      countryList: [],
      validationErrors: [],
      keywordsList: [],
      topicList: [],
      folderList: [],
      folderId: null,
      languages: languages,
      referralOptions: referralOptions,
      onboardOptions: onboardOptions,
      currentKeyword: '',
      channelOptions: channelOptions,
      genderOptions: genderOptions,
      reminderOptions: reminderOptions,
      conversationsList: [],
      gRowObj: {
        customQuery: '',
        id: null,
        channels: [],
        gender: [],
        keywords: [],
        keyword_operator: null,
        language_operator: null,
        dateFrom: '',
        dateTo: '',
        language: [],
        minAge: '',
        referralStatus: '',
        reminderRestriction: '',
        onboardStatus: [],
        maxAge: '',
        query_name: '',
        country_id: null,
        conversations: [],
        topic_id: null,
        active_conversations_include: [],
        active_conversations_exclude: []
      },
      submitted: false,
      showTranscriptModal: false,
      submittedTransriptNumber: false,
      transcriptNumber: '',
      accountIds: [],
      dateTypeMappings: dateTypeMappings,
      dateType: 'engagementDate',
      options: [],
      transcriptIds: [],
      isGenAITranscript: false
    }
  },
  async mounted () {
    this.loading = true
    this.env = await getEnv()
    await this.getCountryList()
    await this.getTopics()
    if (this.$route.query.queryId) {
      await this.fetchAudienceQuery(this.$route.query.queryId)
    }
    await this.fetchFolders()
    this.loading = false
  },
  computed: {
    filteredKeywords () {
      return this.keywordsList.map(i => { return { id: i, label: i } })
    }
  },
  methods: {
    getMinDate (date) {
      return moment(date).subtract(6, 'months').format('YYYY-MM-DD')
    },
    getMaxDate (date) {
      return moment(date).add(6, 'months').format('YYYY-MM-DD')
    },

    openModal (isGenAITranscript = false) {
      this.isGenAITranscript = isGenAITranscript
      if (!this.isFormValid()) return
      this.showTranscriptModal = true
    },

    async exportTranscripts (e) {
      this.$v.$touch()
      this.submittedTransriptNumber = true
      if (this.$v.transcriptNumber.$invalid) {
        return
      }
      this.submittedTransriptNumber = false
      this.showTranscriptModal = false
      this.fetchAudienceData(false, this.transcriptNumber).then(() => {
        this.accountIds = this.transcriptIds.map(audience => audience.accountId)
        if (this.accountIds[0] === null) {
          this.transcriptNumber = ''
          return this.$swal({
            type: 'error',
            text: 'No audience found for the given criteria'
          })
        }
        this.uploadTranscripts()
      })
      this.transcriptNumber = ''
    },

    async uploadTranscripts () {
      let allAttributes = {
        query: this.gRowObj.customQuery.replace(/;$/, ''),
        queryName: this.gRowObj.query_name,
        countryId: this.gRowObj.country_id,
        topicId: this.gRowObj.topic_id,
        country_name: this.countryList.find(item => item.id === this.gRowObj.country_id).label,
        minAge: this.gRowObj.minAge,
        maxAge: this.gRowObj.maxAge,
        genders: this.gRowObj.gender.join(),
        languages: this.gRowObj.language.map(item => item).join(),
        languagesOp: this.gRowObj.language_operator,
        channels: this.gRowObj.channels.join(),
        referralStatus: this.gRowObj.referralStatus,
        onboardStatus: this.gRowObj.onboardStatus.join(),
        reminderRestriction: this.gRowObj.reminderRestriction,
        keywords: this.gRowObj.keywords.map(item => item).join(),
        keywordsOp: this.gRowObj.keyword_operator,
        needSampleData: false,
        numberOfTranscripts: this.transcriptNumber,
        activeConversationsToInclude: this.gRowObj.active_conversations_include.join(),
        activeConversationsToExclude: this.gRowObj.active_conversations_exclude.join(),
        ...this.dateType === 'engagementDate' ? {
          engagementStartDate: moment.utc(this.gRowObj.dateFrom).startOf('day').utc(true),
          engagementEndDate: moment.utc(this.gRowObj.dateTo).endOf('day').utc(true)
        } : {
          onboardStartDate: moment.utc(this.gRowObj.dateFrom).startOf('day').utc(true),
          onboardEndDate: moment.utc(this.gRowObj.dateTo).endOf('day').utc(true)
        }
      }
      let params = Object.entries(allAttributes).reduce((a, [k, v]) => { let val = (v == null || v === '' ? a : (a[k] = v, a)); return val }, {})
      params.conversations = JSON.stringify(this.formatConversationData(this.gRowObj.conversations))
      this.loading = true
      try {
        const response = await apiold.buildRequest(`/audience/exportTranscripts`, 'POST', { audience: this.accountIds, audienceName: this.gRowObj.query_name, params, countryName: allAttributes.country_name, isGenAITranscript: this.isGenAITranscript })
        this.loading = false
        this.$swal({
          type: 'success',
          html: response.data.payload.html ? response.data.payload.html : 'Exported transcripts successfully'
        })
      } catch (error) {
        this.loading = false
        this.$swal({
          type: 'error',
          text: error.response ? error.response.data.payload.message : 'An error occurred'
        })
      }
      this.isGenAITranscript = false
    },

    closeModal () {
      this.showTranscriptModal = false
      this.transcriptNumber = ''
    },

    handleQueryUseChange () {
      this.gRowObj = {
        ...this.gRowObj,
        dateFrom: '',
        dateTo: ''
      }
    },
    async fetchAudienceQuery (queryId) {
      this.loading = true
      const params = {
        id: queryId
      }
      try {
        const response = await api.get(`audience-builder/${this.env.env}/queries`, { params: params, baseURL: this.env.baseURL })
        const updateQryData = response.data.data[0]
        const customQuery = updateQryData.criteria.query

        this.gRowObj.id = updateQryData.id
        this.gRowObj.query_name = updateQryData.query_name ? updateQryData.query_name : ''
        this.gRowObj.country_id = updateQryData.country_id ? updateQryData.country_id : ''
        this.folderId = updateQryData.audience_folder_id ? updateQryData.audience_folder_id : null
        this.gRowObj.customQuery = customQuery || ''

        if (updateQryData.criteria) {
          if (updateQryData.criteria.engagementStartDate || updateQryData.criteria.engagementEndDate) this.dateType = 'engagementDate'
          else if (updateQryData.criteria.onboardStartDate || updateQryData.criteria.onboardEndDate) this.dateType = 'OnboardedDate'

          this.gRowObj = {...this.gRowObj, ...helpers.formatAudienceQueryRawData(updateQryData)}

          setTimeout(() => {
            this.gRowObj.topic_id = updateQryData.criteria.topicId ? updateQryData.criteria.topicId : null
            this.gRowObj.conversations = updateQryData.criteria.conversations ? updateQryData.criteria.conversations.map((conv, ind) => {
              this.getStageList(conv.conversation, ind)
              return {
                conversation_operator: conv.conversationOp,
                conversation: conv.conversation,
                stageList: [],
                stages: []
              }
            }) : []

            setTimeout(() => {
              this.gRowObj.keywords = updateQryData.criteria.keywords ? updateQryData.criteria.keywords.keywords : []
              this.gRowObj.keyword_operator = updateQryData.criteria.keywords ? updateQryData.criteria.keywords.keywordsOp : null
              this.gRowObj.conversations = updateQryData.criteria.conversations ? updateQryData.criteria.conversations.map((conv, ind) => ({
                ...this.gRowObj.conversations[ind],
                ...conv.stages && {
                  stages: conv.stages.map((stg, index) => {
                    this.getAnswerList(conv.conversation, stg.stage, ind, index, true)
                    return {
                      answers: [],
                      answers_operator: null,
                      answerList: [],
                      stage: stg.stage,
                      stage_operator: stg.stageOp,
                      ...stg.answers && {
                        answers: stg.answers,
                        answers_operator: stg.answersOp
                      }
                    }
                  })
                }})) : []
            }, 0)
          }, 0)
        }

        if (this.$route.query.action === 'copyAudience') {
          this.gRowObj.query_name = ''
          this.gRowObj.id = null
        }
        this.loading = false
      } catch (error) {
        this.loading = false
        this.$swal({
          type: 'error',
          text: error.response ? error.response.data.payload.message : 'An error occurred'
        })
      }
    },
    getCombinationErrorString (entity) {
      return `Combination of ${entity} and operator is required if any one of them are selected`
    },
    addConversation () {
      this.gRowObj.conversations.push({
        conversation: null,
        conversation_operator: null,
        stageList: [],
        stages: []
      })
    },
    deleteConversation (index) {
      this.gRowObj.conversations.splice(index, 1)
    },
    addStage (index) {
      this.gRowObj.conversations[index].stages.push({
        answers: [],
        answers_operator: null,
        answerList: [],
        stage: null,
        stage_operator: null
      })
    },
    deleteStage (index, stageIndex) {
      this.gRowObj.conversations[index].stages.splice(stageIndex, 1)
    },
    checkNoteForNotOnboarded () {
      if (JSON.stringify(this.gRowObj.onboardStatus) === JSON.stringify([2]) && this.dateType === 'OnboardedDate') this.notOnboardNote = true
      else this.notOnboardNote = false
    },
    handleDateTypeChange (val) {
      this.dateType = val
      this.handleQueryUseChange()
      this.checkNoteForNotOnboarded()
    },
    resetDateType () {
      this.dateType = ''
      this.handleQueryUseChange()
      this.checkNoteForNotOnboarded()
    },
    handleCountryChange (event, event2) {
      this.keywordsList = []
      this.conversationsList = []
      this.keywordDisabled = true
      this.conversationDisabled = true
      this.gRowObj.conversations = []
      this.gRowObj.keywords = []
      this.gRowObj.keyword_operator = null
      this.gRowObj.topicList = []
      this.gRowObj.topic_id = null
      if (this.gRowObj.country_id && this.countryList.length) {
        this.getKeywordsList({ countryId: this.gRowObj.country_id })
        this.getConversationsList()
      }
    },
    handleTopicChange () {
      this.keywordsList = []
      this.gRowObj.keywords = []
      this.keywordDisabled = true
      if (this.gRowObj.country_id) {
        const param = {
          countryId: this.gRowObj.country_id
        }
        if (this.gRowObj.topic_id) {
          param.topicId = this.gRowObj.topic_id
        }
        this.getKeywordsList(param)
      }
    },
    async fetchFolders () {
      this.loading = true
      try {
        const response = await apiold.buildRequest(`/audience/getAllFolders`, 'POST')
        const formattedData = formatter.formatFolderRawData(response.data.payload)
        this.folderList = formattedData.map(folder => {
          return { id: folder.id, label: folder.folderName }
        })
        this.loading = false
      } catch (error) {
        this.loading = false
        this.$swal({
          type: 'error',
          text: error.response ? error.response.data.payload.message : 'An error occurred'
        })
      }
    },
    async getCountryList () {
      try {
        const response = await apiold.buildRequest(`/getCountryList`, 'POST')
        this.countryList = response.data.payload.map(item => { return { id: item.country_id, label: item.country_name } })
      } catch (error) {
        this.loading = false
        this.$swal({
          type: 'error',
          text: error.response ? error.response.data.payload.message : 'An error occurred'
        })
      }
    },
    async getTopics () {
      try {
        const response = await apiold.buildRequest('/getTopics', 'POST')
        this.loading = false
        this.topicList = response.data.payload.map(item => { return { id: item.id, label: item.display_name } })
      } catch (error) {
        this.loading = false
        this.$swal({
          type: 'error',
          text: error.response ? error.response.data.payload.message : 'An error occurred'
        })
      }
    },
    async getKeywordsList (param) {
      try {
        const response = await apiold.buildRequest(`/getAllKeywords`, 'POST', param)
        this.keywordsList = response.data.payload.map(item => { return item.keyword })
        this.keywordDisabled = false
      } catch (error) {
        this.$swal({
          type: 'error',
          text: error.response ? error.response.data.payload.message : 'An error occurred'
        })
      }
    },
    async refreshKeywordsList (param) {
      try {
        this.loading = true
        const response = await apiold.buildRequest(`/getAllKeywords`, 'POST', param)
        this.keywordsList = response.data.payload.map(item => { return item.keyword })
        this.keywordDisabled = false
        this.loading = false
      } catch (error) {
        this.loading = false
        this.$swal({
          type: 'error',
          text: error.response ? error.response.data.payload.message : 'An error occurred'
        })
      }
    },
    async getConversationsList () {
      try {
        this.loading = true
        const response = await apiold.buildRequest(`/getDeployedApps`, 'GET')
        this.conversationsList = response.data.payload.map(item => { return { id: item.appName, label: item.appName } })
        this.options = this.conversationsList
        this.conversationDisabled = false
        this.loading = false
      } catch (error) {
        this.loading = false
        this.$swal({
          type: 'error',
          text: error.response ? error.response.data.payload.message : 'An error occurred'
        })
      }
    },
    resetStages (conversationIndex, conversationOperator) {
      if (conversationOperator === this.equalNotEqualOptions.find(item => item.label === 'NOT EQUALS').id) {
        this.gRowObj.conversations[conversationIndex].stages = []
      }
    },
    async getStageList (conversation, conversationIndex) {
      if (this.gRowObj.conversations[conversationIndex]) {
        this.gRowObj.conversations[conversationIndex].stages = []
        this.gRowObj.conversations[conversationIndex].conversation_operator = conversation ? this.equalNotEqualOptions.find(item => item.label === 'EQUALS').id : null
      }
      const param = {
        conversation: conversation
      }
      try {
        const response = await apiold.buildRequest(`/getStageData`, 'GET', param)
        this.gRowObj.conversations[conversationIndex].stageList = response.data.payload.map(item => { return { id: item.stage, label: item.stage } })
      } catch (error) {
        this.$swal({
          type: 'error',
          text: error.response ? error.response.data.payload.message : 'An error occurred'
        })
      }
    },
    resetAnswers (conversationIndex, stageIndex, stageOperator) {
      if (stageOperator === this.equalNotEqualOptions.find(item => item.label === 'NOT EQUALS').id) {
        this.gRowObj.conversations[conversationIndex].stages[stageIndex].answers = []
        this.gRowObj.conversations[conversationIndex].stages[stageIndex].answers_operator = null
      }
    },
    async getAnswerList (conversation, stage, conversationIndex, stageIndex, isEdit = false) {
      if (!isEdit) {
        this.gRowObj.conversations[conversationIndex].stages[stageIndex].answers = []
        this.gRowObj.conversations[conversationIndex].stages[stageIndex].answers_operator = null
      }
      const param = {
        conversation: conversation,
        stage: stage
      }
      if (this.gRowObj.conversations[conversationIndex].stages[stageIndex]) {
        this.gRowObj.conversations[conversationIndex].stages[stageIndex].stage_operator = stage ? this.equalNotEqualOptions.find(item => item.label === 'EQUALS').id : null
      }
      if (stage) {
        try {
          const response = await apiold.buildRequest(`/getAnswerData`, 'GET', param)
          if (this.gRowObj.conversations[conversationIndex] && this.gRowObj.conversations[conversationIndex].stages[stageIndex]) {
            this.gRowObj.conversations[conversationIndex].stages[stageIndex].answerList = response.data.payload.map(item => { return { id: item.answer, label: item.answer } })
          }
        } catch (error) {
          this.$swal({
            type: 'error',
            text: error.response ? error.response.data.payload.message : 'An error occurred'
          })
        }
      }
    },
    handleLanguageChange (lang) {
      if (lang.length && !this.gRowObj.language_operator) this.gRowObj.language_operator = this.inNotInOptions.find(item => item.label === 'IN').id
      else if (!lang.length) this.gRowObj.language_operator = null
    },
    handleAnswerChange (conversationIndex, stageIndex, answers, answersOperator) {
      if (answers.length && !answersOperator) this.gRowObj.conversations[conversationIndex].stages[stageIndex].answers_operator = this.inNotInOptions.find(item => item.label === 'IN').id
      else if (!answers.length) this.gRowObj.conversations[conversationIndex].stages[stageIndex].answers_operator = null
    },
    update (newTags) {
      if (newTags.length !== 0 && !this.gRowObj.keyword_operator) this.gRowObj.keyword_operator = this.inNotInOptions.find(item => item.label === 'IN').id
      else if (!newTags.length) this.gRowObj.keyword_operator = null
      this.gRowObj.keywords = newTags
    },
    isFormValid () {
      this.submitted = true
      this.$v.$touch()
      if (this.$v.gRowObj.$invalid) {
        return false
      }
      return true
    },
    async getAudience (e) {
      if (!this.isFormValid()) return
      await this.fetchAudienceData(true)
    },
    async exportAudience () {
      if (!this.isFormValid()) return
      const data = await this.fetchAudienceData(false)
      data.length && downloadCSV({
        fields: ['Account Id'],
        data: data.map(ele => _.values(_.omit(ele, 'key')))
      }, 'Audience')
    },
    async fetchAudienceData (needSampleData, numberofTranscripts = 0) {
      let allAttributes = {
        query: this.gRowObj.customQuery.replace(/;$/, ''),
        queryName: this.gRowObj.query_name,
        countryId: this.gRowObj.country_id,
        topicId: this.gRowObj.topic_id,
        country_name: this.countryList.find(item => item.id === this.gRowObj.country_id).label,
        minAge: this.gRowObj.minAge,
        maxAge: this.gRowObj.maxAge,
        genders: this.gRowObj.gender.join(),
        languages: this.gRowObj.language.map(item => item).join(),
        languagesOp: this.gRowObj.language_operator,
        channels: this.gRowObj.channels.join(),
        referralStatus: this.gRowObj.referralStatus,
        onboardStatus: this.gRowObj.onboardStatus.join(),
        reminderRestriction: this.gRowObj.reminderRestriction,
        keywords: this.gRowObj.keywords.map(item => item).join(),
        keywordsOp: this.gRowObj.keyword_operator,
        needSampleData: needSampleData,
        numberOfTranscripts: numberofTranscripts,
        activeConversationsToInclude: this.gRowObj.active_conversations_include.join(),
        activeConversationsToExclude: this.gRowObj.active_conversations_exclude.join(),
        ...this.dateType === 'engagementDate' ? {
          engagementStartDate: moment.utc(this.gRowObj.dateFrom).startOf('day').utc(true),
          engagementEndDate: moment.utc(this.gRowObj.dateTo).endOf('day').utc(true)
        } : {
          onboardStartDate: moment.utc(this.gRowObj.dateFrom).startOf('day').utc(true),
          onboardEndDate: moment.utc(this.gRowObj.dateTo).endOf('day').utc(true)
        }
      }
      let params = Object.entries(allAttributes).reduce((a, [k, v]) => { let val = (v == null || v === '' ? a : (a[k] = v, a)); return val }, {})
      params.conversations = JSON.stringify(this.formatConversationData(this.gRowObj.conversations))
      params.include_tnc_false_users = this.isGenAITranscript
      this.loading = true
      try {
        const response = await api.post(`audience-builder/${this.env.env}/users/re-engagement-audience`, params, { baseURL: this.env.baseURL })
        this.loading = false
        if (needSampleData) {
          this.audienceCount = response.data.totalCounts
          this.audienceData = this.formatAudienceRawData(response.data.data)
        } else if (numberofTranscripts) {
          this.transcriptIds = this.formatAudienceRawData(response.data.data)
        } else {
          return this.formatAudienceRawData(response.data)
        }
      } catch (error) {
        this.loading = false
        this.$swal({
          type: 'error',
          text: error.response ? error.response.data.message : 'An error occurred'
        })
      }
    },
    formatAudienceRawData (rawData) {
      return rawData.map((ele, index) => ({
        key: index,
        accountId: ele.accountId,
        country: ele.country || '-',
        channel: ele.usertype || '-',
        gender: ele.gender || '-',
        age: ele.age || '-',
        language: ele.language || '-',
        sessionId: ele.sessionId,
        keyword: ele.keyword,
        conversation: ele.conversation,
        stage: ele.stage,
        answer: ele.answer,
        queText: ele.queText,
        createdDate: moment(ele.engagementCreatedAt).utc().format(`DD-MMM-YYYY, hh:mm A`)
      }))
    },
    async saveAudienceData () {
      if (!this.isFormValid()) return
      let criteria = {
        query: this.gRowObj.customQuery.replace(/;$/, ''),
        channels: this.gRowObj.channels,
        genders: this.gRowObj.gender,
        minAge: parseInt(this.gRowObj.minAge),
        maxAge: parseInt(this.gRowObj.maxAge),
        topicId: this.gRowObj.topic_id,
        referralStatus: this.gRowObj.referralStatus,
        onboardStatus: this.gRowObj.onboardStatus.join(),
        reminderRestriction: this.gRowObj.reminderRestriction,
        activeConversationsToInclude: this.gRowObj.active_conversations_include.join(),
        activeConversationsToExclude: this.gRowObj.active_conversations_exclude.join(),
        ...this.dateType === 'engagementDate' ? {
          engagementStartDate: moment.utc(this.gRowObj.dateFrom).startOf('day').utc(true),
          engagementEndDate: moment.utc(this.gRowObj.dateTo).endOf('day').utc(true)
        } : {
          onboardStartDate: moment.utc(this.gRowObj.dateFrom).startOf('day').utc(true),
          onboardEndDate: moment.utc(this.gRowObj.dateTo).endOf('day').utc(true)
        }
      }
      criteria = Object.entries(criteria).reduce((a, [k, v]) => { let val = (v == null || v === '' ? a : (a[k] = v, a)); return val }, {})

      if (this.gRowObj.keywords.length && this.gRowObj.keyword_operator) criteria.keywords = { keywords: this.gRowObj.keywords.map(item => item), keywordsOp: this.gRowObj.keyword_operator }
      if (this.gRowObj.language.length && this.gRowObj.language_operator) criteria.languages = { languages: this.gRowObj.language.map(item => item), languagesOp: this.gRowObj.language_operator }
      criteria.conversations = this.formatConversationData(this.gRowObj.conversations)

      const params = {
        id: this.gRowObj.id,
        query_name: this.gRowObj.query_name,
        country_id: this.gRowObj.country_id,
        country_name: this.countryList.find(item => item.id === this.gRowObj.country_id).label,
        criteria,
        audience_folder_id: this.folderId ? this.folderId : null,
        query: this.customQuery
      }
      this.loading = true

      try {
        const response = await api.post(`audience-builder/${this.env.env}/queries/save`, params, { baseURL: this.env.baseURL })
        this.loading = false
        const status = response.status === 200 ? 'success' : 'error'
        if (status === 'success') {
          this.$swal({
            type: 'success',
            text: 'Query saved successfully'
          }).then(() => {
            this.$router.push({ name: 'audience-builder/view' })
          })
        } else {
          this.$swal({
            type: 'error',
            text: response ? response.data.message : 'An error occurred'
          })
        }
      } catch (error) {
        this.loading = false
        if (error.response && error.response.status === 409) {
          this.$swal({
            type: 'error',
            title: 'Save Audience',
            text: 'Audience query with same name already exists'
          })
        } else {
          this.$swal({
            type: 'error',
            title: 'Save Audience',
            text: error.response.data.message ? error.response.data.message : 'An error occurred'
          })
        }
      }
    },
    formatConversationData (conversationData) {
      return conversationData.map((conv) => ({
        conversationOp: conv.conversation_operator,
        conversation: conv.conversation,
        stages: conv.stages.map(stg => ({
          stage: stg.stage,
          stageOp: stg.stage_operator,
          ...stg.answers && {
            answers: stg.answers,
            answersOp: stg.answers_operator
          }
        }))
      }))
    }
  }
}
</script>
<style>
  .note-label {
    color:#ff7890;
    margin-left:25px;
    margin-bottom:10px;
    font-size:14px;
  }
  .btn-remove-item {
    white-space: break-spaces;
  }
  .vue-treeselect__label {
    white-space: pre-wrap !important;
    overflow-wrap: break-word;
  }
  .ti-disabled {
    background-color: #eee !important;
    cursor: not-allowed;
  }
  .margin-left-10 {
    margin-left: 10px;
  }
  .margin-bottom-20 {
    margin-bottom: 20px;
  }
  .margin-left-15 {
    margin-left: 15px;
  }
  .margin-top-20 {
    margin-top: 20px;
  }
  .margin-20 {
    margin: 20px;
  }
  .padding-20 {
    padding: 20px;
  }
  .border-grey {
    border: 1px solid grey;
  }
  .dropdown-menu {
    font-size: 15px;
  }
  .vue-treeselect__control,
  .v-select .dropdown-toggle {
    border-radius: 0px;
  }
  .vue-treeselect.vue-treeselect--disabled {
    cursor: not-allowed;
  }
  .vue-treeselect:not(.vue-treeselect--disabled) .vue-treeselect__multi-value-item:not(.vue-treeselect__multi-value-item-disabled):hover .vue-treeselect__multi-value-item:not(.vue-treeselect__multi-value-item-new) .vue-treeselect__multi-value-item:not(.vue-treeselect__multi-value-item-new):hover, .vue-treeselect__multi-value-item {
    background-color: #f0f0f0;
    border: 1px solid #ccc;
    border-radius: 4px;
    color: #333;
  }
  .vue-treeselect__value-remove {
    color: #333;
  }
  .required:after {
    content:" *";
    color: red;
  }
.label-custom{
  margin-top: 22px;
  margin-left: 5px;
}
.ab-hint-text {
  color: red;
  font-size: 14px;
  font-weight: bold;
}
/* Refresh icon next to field labels (unscoped: shared by keyword, opportunity, stage and audit forms) */
.rotate{
  color: #0D9488;
  font-size: 15px;
  transition: color 0.15s ease, transform 0.3s ease;
}
.rotate:hover{
  color: #0B7C72;
  transform: rotate(90deg);
}
.reload-audience-builder {
  display: flex;
}
.reload-conversation-audience-builder {
  display: flex;
}
.reload-inclusion-conversation {
  display: flex;
}
.reload-exclusion-conversation {
  display: flex;
}
</style>


// WEBPACK FOOTER //
// form.vue?27fe46ba